import { useState } from 'react'
import { Button, Card, CardContent, CardHeader, CardTitle, Input } from '../../components/ui'
import { authService } from '../../services/auth.service'

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('')
  const [submitting, setSubmitting] = useState(false)
  const [sent, setSent] = useState(false)
  const [error, setError] = useState('')

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError('')
    if (!email.trim()) {
      setError('Please enter your email address')
      return
    }
    setSubmitting(true)
    try {
      await authService.requestPasswordReset(email.trim())
      setSent(true)
    } catch (err: any) {
      setError(err?.response?.data?.message || 'Failed to send the reset email. Please try again.')
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <div className="min-h-screen bg-neutral-50 flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <Card>
          <CardHeader>
            <CardTitle>Forgot your password?</CardTitle>
          </CardHeader>
          <CardContent>
            {sent ? (
              <div className="space-y-4">
                <p className="text-sm text-neutral-700">
                  If an account exists for <strong>{email}</strong>, a password reset link has been
                  sent. The link is valid for 60 minutes.
                </p>
                <p className="text-xs text-neutral-500">
                  Didn't receive it? Check your spam folder or try again.
                </p>
                <a href="/forgot-password" className="text-sm text-primary-600 hover:underline">
                  Send another
                </a>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="space-y-4">
                <p className="text-sm text-neutral-600">
                  Enter your account email and we'll send you a reset link.
                </p>
                <Input
                  label="Email Address"
                  type="email"
                  placeholder="your@email.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
                {error && <p className="text-sm text-red-600">{error}</p>}
                <Button type="submit" disabled={submitting} className="w-full">
                  {submitting ? 'Sending…' : 'Send reset link'}
                </Button>
              </form>
            )}
            <div className="mt-4 text-center">
              <a href="/login" className="text-sm text-primary-600 hover:underline">
                ← Back to login
              </a>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  )
}
